/**
 * Kinds of agenda items that can be attached to a team calendar entry.
 *
 * An agenda item is a self-contained piece of behavior bolted onto an
 * entry — similar to how Google Calendar lets you attach a conference,
 * attachment, or reminder to an event without changing the event's type.
 *
 * Adding a new item type = appending a member here, adding a schema file
 * under ./items/, registering it in the discriminated union, and providing
 * a handler implementation in the service layer.
 */
export enum TeamCalendarEntryAgendaItemType {
  Promotion = "promotion",
}
